import { useEffect } from "react"
import styles from "./analytics-chart.module.css"

export default function ProfitChart({ data }) {
  if (!data || data.length === 0) {
    return (
      <div className={styles.chartContainer}>
        <h2>Daily Profit Trend</h2>
        <div className={styles.noData}>No data available</div>
      </div>
    )
  }

  const maxProfit = Math.max(...data.map((d) => d.profit))

  return (
    <div className={styles.chartContainer}>
      <h2>Daily Profit Trend</h2>
      <div className={styles.chart}>
        {data.map((item, index) => {
          const heightPercent = (item.profit / maxProfit) * 100

          return (
            <div key={index} className={styles.bar} title={`${item.date}: ₹${item.profit.toFixed(2)}`}>
              <div className={styles.barFill} style={{ height: `${heightPercent}%` }} />
              <span className={styles.barLabel}>{new Date(item.date).getDate()}</span>
            </div>
          )
        })}
      </div>
    </div>
  )
}
